module.exports = __webpack_public_path__ + "img/spicy-burgers.90d23284.jpg";